import React from 'react';
import './loader.scss';




const PreLoaderWidget = () => (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "88vh" }}>
        <img
            src="/images/logo.png"
            alt="Logo Loader"
            className='loader-img'
        />
        <span className="loading-text">Loading...</span>
    </div>
);

export default PreLoaderWidget;
